import Choices from 'choices.js';

// Importa Feather Icons
import feather from "feather-icons";

function setupCountrySelect() {
    // AJAX per popolamento select nazioni
    const countrySelects = document.querySelectorAll('select.js-choices-select[name="nazione"]');
    if (countrySelects) {
        countrySelects.forEach(countrySelect => {
            var form = countrySelect.closest('form');
            var lang = form.getAttribute('data-lang') || 'it';
            // Inizializza Choices.js dopo aver popolato le opzioni
            var instance = new Choices(countrySelect, {
                searchEnabled: true,
                itemSelectText: '',
                shouldSort: true,
                placeholderValue: countrySelect.getAttribute('data-placeholder') || 'Select a country',
            });

            const uniqueId = 'choices-' + Math.random().toString(36).substr(2, 9);
            window.choicesInstancesMap[uniqueId] = instance;
            countrySelect.setAttribute('data-choices-id', uniqueId);
        });
    }
}

function setupProvinceSelect() {
    // Inizializza Choices.js sul select provincia
    const provinceSelects = document.querySelectorAll('select.js-choices-select[name="provincia"]');
    if (provinceSelects) {
        provinceSelects.forEach(provinceSelect => {
            var instance = new Choices(provinceSelect, {
                searchEnabled: true,
                itemSelectText: '',
                shouldSort: false,
                placeholderValue: provinceSelect.getAttribute('data-placeholder') || 'Select a province',
            });

            const uniqueId = 'choices-' + Math.random().toString(36).substr(2, 9);
            window.choicesInstancesMap[uniqueId] = instance;
            provinceSelect.setAttribute('data-choices-id', uniqueId);
        });
    }

    // Gestione abilitazione/disabilitazione select provincia
    document.querySelectorAll('.change-provincia').forEach(select => {
        select.addEventListener('change', function () {
            var form = this.closest('form');
            // Aggiorna il select delle province in base alla nazione selezionata
            var provinceSelect = form.querySelector('select[name="provincia"]');
            var provinceData = provinceSelect.getAttribute('data-province');
            var provinceList = provinceData ? JSON.parse(provinceData) : {};
            var provinceOptions = provinceList[this.value.toUpperCase()] || [];

            // Get choice instance for province select
            const uniqueId = provinceSelect.getAttribute('data-choices-id');
            const choicesInstance = window.choicesInstancesMap[uniqueId];

            // Aggiorna le opzioni del select provincia
            choicesInstance.clearStore();
            if (provinceOptions.length > 0) {
                provinceOptions.forEach(prov => {
                    choicesInstance.setChoices([{ value: prov.sigla, label: prov.nome }], 'value', 'label', false);
                });
            }

            // Da modificare quando avremo le aree estere confermate. Ora mostra solo "Estero" se la nazione è diversa da Italia
            if (this.value.toLowerCase() == 'it') {

                choicesInstance.config.placeholderValue = provinceSelect.getAttribute('data-placeholder') || 'Select a province';
                choicesInstance.containerOuter.element.style.display = 'block';

                const esteroText = form.querySelector('.estero-text');
                if (esteroText) {
                    esteroText.style.display = 'none';
                }

                choicesInstance.removeActiveItems();
                choicesInstance.enable();

            } else {

                console.log(choicesInstance);

                choicesInstance.config.placeholderValue = provinceSelect.getAttribute('data-placeholder-estero') || 'Select an area';
                choicesInstance.setChoiceByValue('Estero');
                // choicesInstance.disable();

                choicesInstance.containerOuter.element.style.display = 'none';

                const esteroText = form.querySelector('.estero-text');
                if (esteroText) {
                    esteroText.style.display = 'flex';
                }

            }
        });
    });
}

function setupCandidature() {

    const lavoraConNoiForm = document.getElementById('lavora-con-noi');
    if (!lavoraConNoiForm) {
        return;
    }

    console.log('Inizializzazione upload candidature...');

    const csrfToken = lavoraConNoiForm.querySelector('input[name="token"]').value;
    let cvMetadata = null;
    let coverLetterMetadata = null;

    // Upload CV
    const cvWrapper = document.getElementById('cv-upload-wrapper');
    const cvFileTitle = cvWrapper.querySelector('.file-title');

    cvWrapper.addEventListener('click', function (e) {
        // e.preventDefault();
        console.log('Click su CV upload');

        const input = cvWrapper.querySelector('input[type="file"]');

        input.onchange = async function (e) {
            const file = e.target.files[0];
            if (!file) return;

            console.log('File CV selezionato:', file.name);
            cvFileTitle.innerHTML = file.name;

            try {
                // 1. Ottieni presigned URL da S3
                const presignResponse = await fetch(cvWrapper.dataset.uploadUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': csrfToken
                    },
                    body: JSON.stringify({
                        filename: file.name,
                        contentType: file.type
                    })
                });

                if (!presignResponse.ok) {
                    const errorText = await presignResponse.text();
                    console.error('Errore presign response:', errorText);
                    throw new Error('Errore ottenimento presigned URL');
                }

                const presignData = await presignResponse.json();
                console.log('Presigned URL ottenuto per CV:', presignData);

                // 2. Upload diretto su S3
                const uploadResponse = await fetch(presignData.url, {
                    method: presignData.method,
                    headers: presignData.headers,
                    body: file
                });

                if (!uploadResponse.ok) {
                    throw new Error('Errore upload su S3');
                }

                console.log('Upload CV su S3 completato');

                // 3. Usa la chiave S3 dalla risposta del presigned URL
                const s3Key = presignData.s3_key;
                console.log('S3 Key da usare:', s3Key);

                // 4. Salva metadata nel database
                cvMetadata = {
                    s3_key: s3Key,
                    filename: file.name,
                    mime_type: file.type,
                    file_size: file.size,
                    media_type: 'cv_candidature'
                };

                await saveMediaToDatabase(cvMetadata, 'cv_candidature');
                console.log('CV salvato con successo');

            } catch (error) {
                console.error('Errore upload CV:', error);
                alert('Errore durante il caricamento del CV. Riprova.');
                cvDisplay.value = '';
            }
        };
    });

    // Upload Cover Letter
    const coverLetterWrapper = document.getElementById('cover-letter-upload-wrapper');
    const cLTitle = coverLetterWrapper.querySelector('.file-title');
    const coverLetterText = document.getElementById('cover-letter-text');

    coverLetterWrapper.addEventListener('click', function (e) {

        console.log('Click su Cover Letter upload');

        const input = coverLetterWrapper.querySelector('input[type="file"]');

        input.onchange = async function (e) {
            const file = e.target.files[0];
            if (!file) return;

            console.log('File Cover Letter selezionato:', file.name);
            cLTitle.innerHTML = file.name;
            coverLetterText.disabled = true; // Disabilita textarea se si carica file

            try {
                // 1. Ottieni presigned URL da S3
                const presignResponse = await fetch(coverLetterWrapper.dataset.uploadUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': csrfToken
                    },
                    body: JSON.stringify({
                        filename: file.name,
                        contentType: file.type
                    })
                });

                if (!presignResponse.ok) {
                    const errorText = await presignResponse.text();
                    console.error('Errore presign response:', errorText);
                    throw new Error('Errore ottenimento presigned URL');
                }

                const presignData = await presignResponse.json();
                console.log('Presigned URL ottenuto per Cover Letter:', presignData);

                // 2. Upload diretto su S3
                const uploadResponse = await fetch(presignData.url, {
                    method: presignData.method,
                    headers: presignData.headers,
                    body: file
                });

                if (!uploadResponse.ok) {
                    throw new Error('Errore upload su S3');
                }

                console.log('Upload Cover Letter su S3 completato');

                // 3. Usa la chiave S3 dalla risposta del presigned URL
                const s3Key = presignData.s3_key;
                console.log('S3 Key da usare:', s3Key);

                // 4. Salva metadata nel database
                coverLetterMetadata = {
                    s3_key: s3Key,
                    filename: file.name,
                    mime_type: file.type,
                    file_size: file.size,
                    media_type: 'cover_letter_candidature'
                };

                await saveMediaToDatabase(coverLetterMetadata, 'cover_letter_candidature');
                console.log('Cover Letter salvata con successo');

            } catch (error) {
                console.error('Errore upload Cover Letter:', error);
                alert('Errore durante il caricamento della Cover Letter. Riprova.');
                coverLetterDisplay.value = '';
                coverLetterText.disabled = false;
            }
        };
    });

    // Check se coverLetterText è modificato manualmente, disabilita il file upload della cover letter
    coverLetterText.addEventListener('input', function () {
        if (this.value.trim() !== '') {
            coverLetterWrapper.querySelector('input[type="file"]').disabled = true;
            coverLetterWrapper.classList.add('disabled');
        } else {
            coverLetterWrapper.querySelector('input[type="file"]').disabled = false;
            coverLetterWrapper.classList.remove('disabled');
        }

    });

    // Funzione per salvare media nel database
    async function saveMediaToDatabase(metadata, mediaType) {
        console.log('Salvataggio media nel database...', metadata);

        const response = await fetch(lavoraConNoiForm.dataset.uploadMediaUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken
            },
            body: JSON.stringify({
                s3_key: metadata.s3_key,
                filename: metadata.filename,
                mime_type: metadata.mime_type,
                file_size: metadata.file_size,
                mediaType: mediaType,
                entityType: 'Forms',
                entityId: 0
            })
        });

        const result = await response.json();

        if (!result.success) {
            throw new Error(result.error || 'Errore salvataggio media');
        }

        console.log('Media salvato nel database:', result);
        return result;
    }

    // Validazione form al submit
    if (lavoraConNoiForm) {
        lavoraConNoiForm.addEventListener('submit', function (e) {
            if (!cvMetadata) {
                e.preventDefault();
                alert('<?= __("È obbligatorio caricare il CV") ?>');
                return false;
            }
        });



    }


}

export function setupForms() {

    // console.log(' Init forms.js');

    window.choicesInstancesMap = window.choicesInstancesMap || {};

    setupCountrySelect();
    setupProvinceSelect();


    var tipologiaSelect = document.querySelector('select.js-choices-select[name="tipologia"]');
    if (tipologiaSelect) {
        var instance = new Choices(tipologiaSelect, {
            searchEnabled: false,
            itemSelectText: '',
            shouldSort: false,
            placeholderValue: tipologiaSelect.getAttribute('data-placeholder') || 'Select an option',
        });

        const uniqueId = 'choices-' + Math.random().toString(36).substr(2, 9);
        window.choicesInstancesMap[uniqueId] = instance;
        tipologiaSelect.setAttribute('data-choices-id', uniqueId);
    }

    if (document.querySelectorAll('.custom-file-upload').length > 0) {
        // Gestione file input personalizzati
        document.querySelectorAll('.custom-file-upload').forEach(wrapper => {
            const fileInput = wrapper.querySelector('input[type="file"]');
            const fileTitle = wrapper.querySelector('.file-title');

            fileInput.addEventListener('change', function (e) {
                fileTitle.innerHTML = '<span>' + this.value.replace(/.*(\/|\\)/, '') + '</span>';
            });
        });
    }


    document.querySelectorAll('.js-toggle-input').forEach(toggle => {

        const targetSelector = toggle.getAttribute('data-target');
        const targetElement = document.querySelector(targetSelector);

        toggle.addEventListener('change', function () {

            if (this.value == 'altro' && this.checked) {
                targetElement.style.display = 'block';
                targetElement.querySelector('input').removeAttribute('disabled');
                return;
            } else {
                targetElement.style.display = 'none';
                targetElement.querySelector('input').setAttribute('disabled', 'disabled');
            }
        });
    });

    // Password visibility toggle
    document.querySelectorAll('.js-toggle-password-visibility').forEach(button => {
        button.addEventListener('click', function () {
            const passwordFieldWrapper = this.closest('.password-field-wrapper');
            const passwordInput = passwordFieldWrapper.querySelector('input[type="password"], input[type="text"]');

            if (passwordInput.type === 'password') {
                passwordInput.type = 'text';
                this.innerHTML = '<i data-feather="eye-off"></i>';
            } else {
                passwordInput.type = 'password';
                this.innerHTML = '<i data-feather="eye"></i>';
            }
            feather.replace({ "stroke-width": 1 });
        });
    });

    if (document.querySelectorAll('form[data-url]').length > 0) {
        // Gestione submit AJAX dei form con data-url
        document.querySelectorAll('form[data-url]').forEach(form => {
            form.addEventListener('submit', async function (e) {
                e.preventDefault();

                const submitButton = this.querySelector('button[type="submit"]');
                const originalButtonText = submitButton?.innerHTML;

                try {
                    // Disabilita il pulsante durante l'invio
                    if (submitButton) {
                        submitButton.disabled = true;
                        submitButton.innerHTML = 'Invio in corso...';
                    }

                    // Raccogli i dati del form
                    const formData = new FormData(this);
                    const data = Object.fromEntries(formData.entries());

                    // Aggiungi i dati dai data attributes
                    data.url = window.location.href;
                    data.form_name = this.getAttribute('data-form-name') || 'unknown';
                    data.lang = this.getAttribute('data-lang') || 'it';

                    // Ottieni l'URL dal data-url attribute
                    const url = this.getAttribute('data-url');

                    // Effettua la richiesta AJAX
                    const response = await fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        body: JSON.stringify(data)
                    });

                    const result = await response.json();

                    if (result.success) {
                        // Nascondi il form
                        this.style.display = 'none';

                        // Crea e mostra il messaggio di successo
                        const successMessage = document.createElement('div');
                        successMessage.className = 'success-message text-center p-4';
                        successMessage.innerHTML = `
                        <div class="mb-3">
                            <svg height="64" width="64" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" xml:space="preserve"><path d="M26 0C11.664 0 0 11.663 0 26s11.664 26 26 26 26-11.663 26-26S40.336 0 26 0m0 50C12.767 50 2 39.233 2 26S12.767 2 26 2s24 10.767 24 24-10.767 24-24 24" fill="currentColor"/><path d="m38.252 15.336-15.369 17.29-9.259-7.407a1 1 0 0 0-1.249 1.562l10 8a1 1 0 0 0 1.373-.117l16-18a1 1 0 1 0-1.496-1.328" fill="currentColor"/></svg>
                        </div>
                        <h3 class="mb-2">${result.message || 'Richiesta inviata con successo!'}</h3>
                        <p class="text-muted">Ti contatteremo al più presto.</p>
                    `;

                        // Inserisci il messaggio dopo il form
                        this.parentNode.insertBefore(successMessage, this.nextSibling);
                    } else {
                        // Mostra messaggio di errore
                        alert(result.message || 'Errore durante l\'invio della richiesta');
                    }

                } catch (error) {
                    console.error('Errore durante l\'invio del form:', error);
                    alert('Si è verificato un errore. Riprova più tardi.');
                } finally {
                    // Riabilita il pulsante
                    if (submitButton) {
                        submitButton.disabled = false;
                        submitButton.innerHTML = originalButtonText;
                    }
                }
            });
        });
    }

    setupCandidature();

    // Newsletter form
    // if (document.querySelectorAll('#newsletter-form').length > 0) {
    //     const newsletterForm = document.getElementById('newsletter-form');
    //     const baseUrl = 'https://a8f1a4.mailupclient.com/frontend/xmlSubscribe.aspx';
    //     newsletterForm.addEventListener('submit', function (e) {
    //         e.preventDefault();
    //         var formData = new FormData(newsletterForm);
    //         var email = formData.get('email');

    //         var params = new URLSearchParams();
    //         formData.forEach(function (value, key) {
    //             params.append(key, value);
    //         });

    //         params.append('confirm', 'true');
    //         params.append('retCode', '1');

    //         var lang = document.documentElement.lang || 'en';

    //         var url = baseUrl;
    //         console.log(url);

    //         var debug = true; // Set to true to enable console logs for debugging

    //         var isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    //         var messaggi = {
    //             'it': {
    //                 'success': 'Iscrizione avvenuta con successo',
    //                 'generic_error': 'Errore, riprovare',
    //                 'invalid_email': 'Errore! Email non valida.<br>Inserisci un indirizzo email valido.',
    //                 'already_subscribed': 'Attenzione! Iscrizione già avvenuta',
    //                 'ip_not_registered': 'Errore! IP non registrato',
    //                 'unknown_error': 'Errore sconosciuto',
    //             },
    //             'en': {
    //                 'success': 'Subscription successful',
    //                 'generic_error': 'Error, please try again',
    //                 'invalid_email': 'Error! Invalid email address.<br>Please enter a valid email.',
    //                 'already_subscribed': 'Warning! Already subscribed',
    //                 'ip_not_registered': 'Error! IP not registered',
    //                 'unknown_error': 'Unknown error',
    //             },
    //             'es': {
    //                 'success': 'Suscripción exitosa',
    //                 'generic_error': 'Error, por favor inténtalo de nuevo',
    //                 'invalid_email': '¡Error! Dirección de correo electrónico no válida.<br>Por favor, ingresa una dirección de correo electrónico válida.',
    //                 'already_subscribed': '¡Advertencia! Ya suscrito',
    //                 'ip_not_registered': '¡Error! IP no registrada',
    //                 'unknown_error': 'Error desconocido',
    //             },
    //             'fr': {
    //                 'success': 'Abonnement réussi',
    //                 'generic_error': 'Erreur, veuillez réessayer',
    //                 'invalid_email': 'Erreur ! Adresse e-mail invalide.<br>Veuillez entrer une adresse e-mail valide.',
    //                 'already_subscribed': 'Attention ! Déjà abonné',
    //                 'ip_not_registered': 'Erreur ! IP non enregistré',
    //                 'unknown_error': 'Erreur inconnue',
    //             }
    //         }

    //         var messaggio = '';

    //         if (email && isValidEmail) {
    //             fetch(url, {
    //                 method: 'POST',
    //                 headers: {
    //                     'Content-Type': 'application/x-www-form-urlencoded',
    //                 },
    //                 body: params.toString(),
    //             })
    //                 .then(response => response.text())
    //                 .then(data => {
    //                     console.log(data);

    //                     /* Check subscription outcome. */
    //                     switch (data) {
    //                         case '0\r\n':
    //                             if (debug)
    //                                 console.log("MailUp: Operation completed successfully");
    //                             messaggio = messaggi[lang] ? messaggi[lang]['success'] : messaggi['en']['success'];
    //                             document.getElementById("nl-response").innerHTML = '<div class="p-4 mt-3 bg-green-800 text-white"><p>' + messaggio + '</p></div>';
    //                             break;
    //                         case '1\r\n':
    //                             if (debug)
    //                                 console.log("MailUp: Generic error");
    //                             messaggio = messaggi[lang] ? messaggi[lang]['generic_error'] : messaggi['en']['generic_error'];
    //                             document.getElementById("nl-response").innerHTML = '<div class="p-4 mt-3 bg-green-800 text-white"><p>' + messaggio + '</p></div>';
    //                             break;
    //                         case '2\r\n':
    //                             if (debug)
    //                                 console.log("MailUp: Invalid email address or mobile number");
    //                             messaggio = messaggi[lang] ? messaggi[lang]['invalid_email'] : messaggi['en']['invalid_email'];
    //                             document.getElementById("nl-response").innerHTML = '<div class="p-4 mt-3 bg-red-800 text-white"><p>' + messaggio + '</p></div>';
    //                             break;
    //                         case '3\r\n':
    //                             if (debug)
    //                                 console.log("MailUp: Recipient already subscribed");
    //                             messaggio = messaggi[lang] ? messaggi[lang]['already_subscribed'] : messaggi['en']['already_subscribed'];
    //                             document.getElementById("nl-response").innerHTML = '<div class="p-4 mt-3 bg-yellow-500 text-black"><p>' + messaggio + '</p></div>';
    //                             break;
    //                         case '-1011\r\n':
    //                             if (debug)
    //                                 console.log("MailUp: IP not registered");
    //                             messaggio = messaggi[lang] ? messaggi[lang]['ip_not_registered'] : messaggi['en']['ip_not_registered'];
    //                             document.getElementById("nl-response").innerHTML = '<div class="p-4 mt-3 bg-red-800 text-white"><p>' + messaggio + '</p></div>';
    //                             break;
    //                         /* By default, subscribe the user */
    //                         default:
    //                             if (debug)
    //                                 console.log("MailUp: Codice restituito sconosciuto");
    //                             messaggio = messaggi[lang] ? messaggi[lang]['unknown_error'] : messaggi['en']['unknown_error'];
    //                             document.getElementById("nl-response").innerHTML = '<div class="p-4 mt-3 bg-red-800 text-white"><p>' + messaggio + '</p></div>';
    //                     } // end of switch

    //                     _iub.cons_instructions.push([
    //                         "submit",
    //                         {
    //                             writeOnLocalStorage: false,
    //                             submitElement: document.getElementById("nl-submit-button"),
    //                             form: {
    //                                 selector:
    //                                     document.getElementById("newsletter-form"),
    //                                 map: {
    //                                     subject: {
    //                                         email: "email",
    //                                     },
    //                                     preferences: {
    //                                         privacy: "privacy",
    //                                     },
    //                                 },
    //                             },
    //                             consent: {
    //                                 legal_notices: [
    //                                     {
    //                                         identifier: "privacy_policy",
    //                                     },
    //                                     {
    //                                         identifier: "cookie_policy",
    //                                     },
    //                                 ],
    //                             },
    //                         },
    //                     ]);
    //                 });
    //         } else {
    //             document.getElementById("nl-response").innerHTML = '<div class="p-4 mt-3 bg-red-800 text-white"><p>Per favore, inserisci un indirizzo email valido.</p></div>';
    //         }
    //     });
    // }
}
